var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsScrollH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM17.7534 8.17906C18.2134 7.79655 19 8.06746 19 8.6084V15.3916C19 15.9325 18.2134 16.2034 17.7534 15.8209L13.6744 12.4293C13.3892 12.1922 13.3892 11.8078 13.6744 11.5707L17.7534 8.17906ZM6.24661 8.17906L10.3256 11.5707C10.6108 11.8078 10.6108 12.1922 10.3256 12.4293L6.24661 15.8209C5.78658 16.2034 5 15.9325 5 15.3916V8.6084C5 8.06746 5.78658 7.79655 6.24661 8.17906Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsScrollH);
export default __webpack_public_path__ + "static/media/arrows-scroll-h.74abca10d425623e439426860edffba6.svg";
export { ForwardRef as ReactComponent };